<template>
    <div class="card card-custom card-stretch mb-5">
        <div class="card-header align-items-center border-0 mt-5">
            <h3 class="card-title align-items-start flex-column">
                <span class="card-label fw-bolder text-dark fs-3">
                    Timeline
                </span>
            </h3>
        </div>
        <div class="card-body pt-12">
            <!--begin::Timeline-->
            <div class="timeline-label">
                <!--begin::Item-->
                <div v-for="item in items" :key="item.id" class="timeline-item" >
                    <!--begin::Label-->
                    <div class="timeline-label fw-bolder text-gray-800 fs-6">{{ item.ts }}</div>
                    <!--end::Label-->

                    <!--begin::Badge-->
                    <div class="timeline-badge">
                        <i class="fa fa-genderless fs-1" v-bind:class="'text-' + item.color"></i>
                    </div>
                    <!--end::Badge-->

                    <!--begin::Text-->
                    <div class="fw-mormal timeline-content text-muted ps-3">
                        {{ item.title }}
                    </div>
                    <!--end::Text-->
                </div>
                <!--end::Item-->
            </div>
            <!--end::Timeline-->
        </div>
    </div>
</template>

<script>
export default{
    setup() {
        const items = [
            {id: 1, ts: "Март 2021", color: 'warning', title: "Старт опционной программы"},
            {id: 2, ts: "Март 2022", color: 'primary', title: "Распределение долей за 2021"},
            {id: 3, ts: "Март 2022", color: 'success', title: "Определение претендентов на опцион за 2022"},
            {id: 5, ts: "Март 2023", color: 'primary', title: "Распределение долей за 2022"},
            {id: 6, ts: "Апрель 2023", color: 'success', title: "Определение претендентов на опцион за 2023"},
            {id: 5, ts: "Март 2024", color: 'primary', title: "Распределение долей за 2023"},
            {id: 6, ts: "Апрель 2024", color: 'success', title: "Определение претендентов на опцион за 2024"},
            {id: 5, ts: "Март 2025", color: 'primary', title: "Распределение долей за 2024"},
            {id: 6, ts: "Апрель 2025", color: 'success', title: "Определение претендентов на опцион за 2025"},
            {id: 7, ts: "Март 2026", color: 'primary', title: "Распределение долей за 2025"},
        ];

        return {
            items
        };
    }
}
</script>
